import CommonService from '@service/commonService'
import '@src/assets/style/login.scss'
import {goto} from '@src/route'
import {setItemObj} from '@src/util/store'
import {Toast} from 'antd-mobile-v2'
import React, {useEffect, useState} from 'react'
import {Md5} from 'ts-md5'

let sending = false

export default function () {
	const [mode, setMode] = useState<'pwd' | 'phone'>('phone')
	const [pwType, setPwType] = useState<string>('text')
	const [u, setU] = useState<string>('')
	const [p, setP] = useState<string>('')
	const [s, setS] = useState<any>(null)
	const [c, setC] = useState<number>(0)
	const [y, setY] = useState<string>('')
	let interval: any

	// const { dispatch } = useContext(GlobalContext)

	function login() {
		if (mode == 'phone') {
			//  验证码登录
			CommonService.codeLogin(u, y).then(res => {
				setItemObj('userInfo', res)
				goto('/')
			}).catch(e => {
				if (typeof e == 'string') {
					Toast.fail(e, 1.4)
				} else {
					Toast.fail('服务连接失败，请联系管理员', 1.5)
				}
			})
		} else {
			const _p = Md5.hashStr(p)
			CommonService.login(u, _p)
				.then((res) => {
					setItemObj('userInfo', res)
					goto('/')
					// dispatch({ type: actionType.SAVE_USER, payload: res })
				})
				.catch((e) => {
					if (typeof e == 'string') {
						Toast.fail(e, 1.4)
					} else {
						Toast.fail('服务连接失败，请联系管理员', 1.5)
					}
				})
		}
	}

	function sendCode() {
		// 发送验证码
		if (c > 0 || sending) return
		let _c = 59;
		sending = true;
		CommonService.sendLoginCode(u).then(rs => {
			interval = setInterval(() => {
				if (_c <= 0) {
					clearInterval(interval)
					setC(0)
					sending = false
					return
				}
				setC(--_c)
			}, 1000)
		}).catch(() => {
			Toast.show('验证码发送失败，请重新发送')
			setC(0)
			sending = false
		})
	}


	const resize = () => {
		const height = window.innerHeight
		setS({
			height: `${height}px`,
		})
	}

	useEffect(() => {
		resize()
		window.addEventListener('resize', resize)
		return () => {
			clearInterval(interval)
			window.removeEventListener('resize', resize)
		}
	}, [])

	return (
		<div className="login-page" style={s}>
			<div className="login-box">
				<div className="title">
					<div onClick={() => setMode('pwd')} className={`item${mode == 'pwd' ? ' active' : ''}`}>密码登录</div>
					<div onClick={() => setMode('phone')}
						 className={`item${mode == 'phone' ? ' active' : ''}`}>手机验证码登录
					</div>
				</div>
				<div className="login-form">
					<div className="login-form-item login-phone">
						<input
							type={'text'}
							value={u}
							placeholder="请输入手机号"
							name="userPhone"
							autoComplete={'off'}
							onChange={(e) => setU(e.target.value)}
						/>
					</div>
					{
						mode == 'pwd' && <div className="login-form-item login-pw">
							<input
								placeholder="请输入密码"
								name="userPwd"
								type={pwType}
								value={p}
								onClick={() => setPwType('password')}
								onChange={(e) => setP(e.target.value)}
							/>
						</div>
					}
					{
						mode == 'phone' && <div className="login-form-item login-code">
							<div className="login-code-input">
								<input placeholder="请输入验证码" value={y} onChange={e => setY(e.target.value)}/>
							</div>
							{/* 验证码 */}
							<div
								className={c > 0 ? 'send-code-btn disable' : 'send-code-btn'}
								onClick={sendCode}
							>{c > 0 ? `重新发送(${c})` : '发送验证码'}</div>
						</div>
					}
					{/*<div><a href="#">忘记密码</a></div>*/}
					<div className="login-form-item login-btn" onClick={() => login()}>
						登录
					</div>
				</div>
			</div>
		</div>
	)
}
